import * as React from 'react'
import type { OptionsDocument, RatesDocument } from 'paintscout'
import type { QuoteTypeOption } from '@paintscout/util/builder'

export interface ClientOptionsValue {
  options?: OptionsDocument
  rates?: RatesDocument

  corporateTypeOptions?: QuoteTypeOption[]

  isAdmin?: boolean
  clientId?: string
  isDirty: boolean

  /**
   * Writes to the db and updates state in ClientOptionsProvider
   */
  save: (args?: {
    options: OptionsDocument
    rates?: RatesDocument
  }) => Promise<{ options: OptionsDocument; rates?: RatesDocument }>

  savePartialOptions: (args: { input: string; key: string }) => Promise<{ output: string }>

  optionsSync: (args: {
    optionsRev: string
    ratesRev: string
  }) => Promise<{ options?: OptionsDocument; rates?: RatesDocument }>

  reset: () => any
  /**
   * Updates state in ClientOptionsProvider but does not write to the db
   * @param args.isDirty defaults to true
   */
  updateOptions: (args: { options: OptionsDocument; isDirty?: boolean }) => void

  /**
   * @param args.isDirty defaults to true
   */
  updateRates: (args: { options: OptionsDocument; rates: RatesDocument; isDirty?: boolean }) => void
}

export default React.createContext<ClientOptionsValue>({
  isDirty: false,
  isAdmin: false,
  clientId: '',
  save: (() => {}) as any,
  savePartialOptions: (() => {}) as any,
  optionsSync: (() => {}) as any,
  reset: () => {},
  updateOptions: () => {},
  updateRates: () => {}
})
